import React, { Fragment, useState, useRef } from "react";
import ToggleButton from "../../PlayerButtons/ToggleButton";

const DiscussionGroupVideos = ({ discussions, showChat }) => {
  const playerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalTwo, setShowModalTwo] = useState(false);
  const [showModalThree, setShowModalThree] = useState(false);
  const [showModalFour, setShowModalFour] = useState(false);
  const [showModalFive, setShowModalFive] = useState(false);
  const [showModalSix, setShowModalSix] = useState(false);
  const [showModalSeven, setShowModalSeven] = useState(false);
  const [showModalEight, setShowModalEight] = useState(false);

  return (
    <Fragment>
      {discussions && discussions.length === 8 ? (
        <div className="video-container-alt" ref={playerRef}>
          <div className="discussion-video-overlay">
            <ToggleButton
              className="Rac__screen-toggle"
              initial={document.fullscreenElement}
              onChange={(active) => {
                if (!active && KeyboardEvent.key === "Escape") {
                  return document.exitFullscreen();
                }

                return playerRef.current.requestFullscreen({
                  navigationUI: "hide",
                });
              }}
            >
              {(active) => {
                if (!active) {
                  return (
                    <div className="watch-stream">
                      <button className="watch-stream-button background-green">
                        <i className="fas fa-expand mx-5"></i>
                        Full Screen
                      </button>
                    </div>
                  );
                }

                if (active) {
                  return (
                    <div className="watch-stream">
                      <button className="watch-stream-button background-green">
                        <i className="far fa-keyboard mx-5"></i>
                        Esc to Exit
                      </button>
                    </div>
                  );
                }
              }}
            </ToggleButton>
          </div>
          <div className="panel">
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-light">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModal) {
                            setShowModal(false);
                          } else {
                            setShowModal(true);
                          }
                        }}
                      ></i>
                      {showModal && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-up fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_141115.mp4"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalTwo) {
                            setShowModalTwo(false);
                          } else {
                            setShowModalTwo(true);
                          }
                        }}
                      ></i>
                      {showModalTwo && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalThree) {
                            setShowModalThree(false);
                          } else {
                            setShowModalThree(true);
                          }
                        }}
                      ></i>
                      {showModalThree && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalFour) {
                            setShowModalFour(false);
                          } else {
                            setShowModalFour(true);
                          }
                        }}
                      ></i>
                      {showModalFour && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      showChat
                        ? "video-stream-live-alt-group green"
                        : "video-stream-live-alt-group-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
          </div>
          <div className="panel">
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalFive) {
                            setShowModalFive(false);
                          } else {
                            setShowModalFive(true);
                          }
                        }}
                      ></i>
                      {showModalFive && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalSix) {
                            setShowModalSix(false);
                          } else {
                            setShowModalSix(true);
                          }
                        }}
                      ></i>
                      {showModalSix && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalSeven) {
                            setShowModalSeven(false);
                          } else {
                            setShowModalSeven(true);
                          }
                        }}
                      ></i>
                      {showModalSeven && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content">
                  <div class="user-overlay-info-alt">
                    <div class="streamer-user-avi-md"></div>
                    <div className="streamer-user-info">
                      <p className="streamer-item bold">User Name</p>
                      <i
                        className="fas fa-ellipsis-v discussion-icon"
                        onClick={() => {
                          if (showModalEight) {
                            setShowModalEight(false);
                          } else {
                            setShowModalEight(true);
                          }
                        }}
                      ></i>
                      {showModalEight && (
                        <div className="modal">
                          <ul className="modal-items">
                            <li className="modal-item">
                              <i className="fas fa-flag mx-5 white"></i>
                              Report
                            </li>
                            <li className="modal-item">
                              <i className="fas fa-ban mx-5 white"></i>
                              Block
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="video-stream-live-alt-group green">
                    <i className="fas fa-circle mx-5"></i>
                    Live
                  </div>
                  <div className="alt-left-items">
                    <ul className="discuss-items">
                      <li className="discuss-item white">
                        <i className="fas fa-vote-yea fa-2x cursor"></i>
                      </li>
                      <li className="discuss-item discuss-font green">3,541</li>
                    </ul>
                  </div>
                  <div className="alt-right-items">
                    <ul className="discuss-items">
                      <li className="discuss-item-mute green">
                        <i className="fas fa-volume-mute fa-2x"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <video
                src={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
                }
                className="fill-video"
              ></video>
            </div>
          </div>
        </div>
      ) : (
        <div className="video-container-alt" ref={playerRef}>
          <div className="panel">
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
          </div>
          <div className="panel">
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
            <div className="live-stream-video-container-alt grey">
              <div className="alt-video-overlay-dark">
                <div className="discuss-content-alt">
                  <div
                    className={
                      showChat
                        ? "video-stream-live green"
                        : "video-stream-live-chat green"
                    }
                  >
                    <i className="fas fa-circle mx-5 green"></i>
                    Live
                  </div>
                </div>
              </div>
              <video
                poster={
                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/IME_OfflinePoster_Final_LogosRemoved2024.jpg"
                }
                className="fill-video"
              ></video>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default DiscussionGroupVideos;
